@if (loadingWrapper.data$|async; as articleList) {
  @if (articleList.length > 0 || filter) {
    <table class="table whitetable business-order-view-table business-order-create">
      <thead>
      <tr>
        <th colspan="4">
          Verwendetes Material&nbsp;
          <button class="btn btn-link"
                  [title]="`Gruppen mit Filter ${!filter ? 'ausblenden' : 'einblenden'}`"
                  (click)="toggleFilter()">
            <i class="fa" [ngClass]="{'fa-eye': !filter, 'fa-eye-slash gray': filter}"></i>
          </button>
        </th>
      </tr>
      </thead>
      <tbody>
      <tr>
        <td><strong>Fertigungsschritt</strong></td>
        <td><strong>Artikel</strong></td>
        <td><strong>Maschine</strong></td>
        <td><strong title="Mindesthaltbarkeit">Min. Halt.</strong></td>
        <td><strong>Charge</strong></td>
      </tr>
        @for (article of articleList; track article) {
          <tr>
            <td><strong>{{ article.step_nr }}</strong>&nbsp;{{ article.step_text }}</td>
            <td>
              <a uiSref="a.material.inventory.update" target="_blank" [uiParams]="{variation: article.id}">
                <strong>{{ article.variation_id }}</strong>&nbsp;{{ article.article_name }}
              </a>
            </td>
            <td>
              {{ article.production_machine_id }} - {{ article.production_machine_name }}
            </td>
            <td>
              {{ article.date_expiration|date:'dd.MM.yyyy' }}
            </td>
            <td>
              <a uiSref="a.material.inventory.update" target="_blank" [uiParams]="{variation: article.id}">
                {{ article.charge }}
              </a>
            </td>
          </tr>
        }
      </tbody>
    </table>
  }
} @else {
  <ng-template [ngTemplateOutlet]="loadingOrError.template"></ng-template>
}

<loading-or-error
  #loadingOrError
  [loadingWrapper]="loadingWrapper"
  [errorMessage]="'Konnte keine Chargen für die Materialien laden'">
</loading-or-error>
